import { Dialog, Box, IconButton, Typography, TextField, Tooltip, Button, Stack } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import LinkIcon from "@mui/icons-material/Link";
import BlockIcon from "@mui/icons-material/Block";
import { useState } from "react";
import { createShareLink, revokeShareLink } from "../../api/integrations";

export default function AgentIntegrationsDialogMobile({ open, onClose, agent, tenantId }) {
  const origin = window.location.origin;
  const embedCode = `<script src="${origin}/embed.js"
  data-tenant-id="${tenantId}"
  data-agent-id="${agent?.id}"
  data-position="bottom-right"
  data-width="380"
  data-height="520"
  async></script>`;

  const iframeCode = `<iframe src="${origin}/chat/${tenantId}/${agent?.id}" width="400" height="600" frameborder="0"></iframe>`;

  const [shareUrl, setShareUrl] = useState("");
  const [shareJti, setShareJti] = useState("");
  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <Box sx={{ display: "flex", alignItems: "center", p: 1.5, borderBottom: 1, borderColor: "divider" }}>
        <Typography sx={{ flex: 1, textAlign: "center", fontWeight: 700 }}>
          Integrations: {agent?.name}
        </Typography>
        <IconButton onClick={onClose} sx={{ position: "absolute", right: 8 }}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Box sx={{ p: 1.5, display: "flex", flexDirection: "column", gap: 2 }}>
        <Box>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Typography variant="subtitle2">Embed Script</Typography>
            <Tooltip title="Copy">
              <IconButton onClick={async () => { try { await navigator.clipboard.writeText(embedCode); } catch {} }} size="small">
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
          <TextField fullWidth multiline value={embedCode} sx={{ mt: 1 }} InputProps={{ readOnly: true }} />
        </Box>
        <Box>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Typography variant="subtitle2">Iframe Embed</Typography>
            <Tooltip title="Copy">
              <IconButton onClick={async () => { try { await navigator.clipboard.writeText(iframeCode); } catch {} }} size="small">
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
          <TextField fullWidth multiline value={iframeCode} sx={{ mt: 1 }} InputProps={{ readOnly: true }} />
        </Box>
        {/* Shareable Link */}
        <Box>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <LinkIcon fontSize="small" /> Shareable Link
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Generate a private link that works even if the agent is not publicly enabled.
          </Typography>
          <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
            <TextField type="number" size="small" label="Expires (days)" sx={{ width: 140 }} defaultValue={7} id="expDays" />
            <TextField type="number" size="small" label="Max uses (0 = unlimited)" sx={{ width: 200 }} defaultValue={0} id="maxUses" />
            <Button size="small" variant="contained" onClick={async () => {
              const exp = Number(document.getElementById("expDays").value || 7);
              const mu = Number(document.getElementById("maxUses").value || 0);
              try {
                const resp = await createShareLink({
                  tenantId,
                  agentId: agent?.id,
                  expiresInSec: exp * 24 * 3600,
                  maxUses: mu,
                });
                setShareUrl(resp?.url || "");
                setShareJti(resp?.jti || "");
              } catch {}
            }}>Generate</Button>
          </Stack>
          {shareUrl && (
            <Stack direction="row" spacing={1}>
              <TextField fullWidth value={shareUrl} InputProps={{ readOnly: true }} />
              <Tooltip title="Copy"><IconButton onClick={async () => { try { await navigator.clipboard.writeText(shareUrl); } catch {} }}><ContentCopyIcon fontSize="small" /></IconButton></Tooltip>
              <Tooltip title="Revoke"><span><IconButton onClick={async () => { try { await revokeShareLink({ tenantId, agentId: agent?.id, jti: shareJti }); setShareUrl(""); setShareJti(""); } catch {} }}><BlockIcon fontSize="small" /></IconButton></span></Tooltip>
            </Stack>
          )}
        </Box>
      </Box>
    </Dialog>
  );
}
